<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!-- <img src="/img/avatars/6.jpg" class="img-avatar" alt="info@adreplay.com" /> -->
      <avatar :username="username" :size="40" class="img-avatar" />
    </template>
    <template slot="dropdown">
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import Avatar from 'vue-avatar'

export default {
  name: 'DefaultHeaderDropdownAccnt',

  components: {
    AppHeaderDropdown,
    Avatar
  },

  computed: {
    username(){
      const firstName = this.$session.get('firstName')
      const lastName = this.$session.get('lastName')
      return [firstName, lastName].join(' ')
    }
  },

  methods: {
    logout(){
      this.$session.clear()
      window.location.reload()
    }
  }
}
</script>
